<template>
  <div v-if="updateDateFormatted" class="text-static-default-mid body-1">
    <p class="hidden md:block">
      {{
        i18n(translations.articleUpdateDate, {
          date: updateDateFormatted,
        })
      }}
    </p>

    <p class="block md:hidden">
      {{ updateDateFormatted }}
    </p>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import translations from './PublicationUpdateDate.translations'

const props = defineProps<{ updateDate?: Date }>()

const i18n = useI18n()

const logger = useLogger()

const updateDateFormatted = computed(() => {
  if (!props.updateDate) {
    return null
  }

  try {
    return i18n.date(props.updateDate, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  } catch (error) {
    logger.error(
      `[COM][Article] Error formatting date ${props.updateDate} in PublicationUpdateDate`,
      { error, owners: ['bot-squad-content-front'] },
    )

    return null
  }
})
</script>
